import React, { useEffect, useState } from "react";
import AddProject from "./AddProject";
import { getAdminUserList } from "../../services/super-admin.service";
import { getProject } from "../../services/Project.service";
import AddIcon from "../../assets/images/add_icon.svg";
import toast from "react-hot-toast";
import PaginatedTable from "../common/PaginatedTable";
import EditIcon from "../../assets/images/edit_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import DeleteIcon from "../../assets/images/delete_icon.svg";
import { projectTypes } from "../../global/transactionTypes"

const AdminList = () => {

  
  const [list, setList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showTable, setShowTable] = useState(true);

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

  const handleShowCreate = () => {
    setShowCreate(true);
    setShowTable(false);
  };

  const back = (cond = true) => {
    cond && projectList();
    setShowCreate(false);
    setShowTable(true);
  };

  useEffect(() => {
    projectList();
  }, [currentPage, itemsPerPage, searchKey ,setSearchKey]);

  const [column, setColumn] = useState([
    {
      heading: () => "S.No",
      cell: (row, i) => {
        return i;
      },
      hidden: false,
      width: "20",
      id: 1,
    },
    {
      heading: () => "Project Name",
      cell: (row) => (row["name"] ? row["name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },

    {
      heading: () => "Type",
      cell: (row) => (row["type"] !=null? projectTypes.find(pt=>pt.key== row["type"] .toString()).value: "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },
    {
      heading: () => "Value",
      cell: (row) => (row["projectValue"] ? row["projectValue"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },
    {
      heading: () => "Expense Value %",
      cell: (row) => (row["expenseValue"] ? row["expenseValue"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },
    {
      heading: () => "Action",
      cell: (row) => (
        <>
          <div>
          <img className="CyanSky_filter" src={ViewIcon} alt="View" />
          {/* <img className="CyanSky_filter" src={EditIcon} alt="Edit" />
          <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" /> */}
          </div>
        </>
      ),

      hidden: false,
      // width: "120",
      // align: "center",
      id: 6,
    },
  ]);

  const projectList = async () => {
    const offset = (currentPage - 1) * itemsPerPage;
    const offsetToUse = offset >= 0 ? offset : 0;

    try {
      const requestBody = {
        offset: offsetToUse,
        limit: itemsPerPage,
        search: searchKey,
      };
      let res = await getProject(requestBody);
      if (res?.data) {
        setList(res?.data);
        setTotalCount(res?.data.length);
      } else {
        toast.error(res?.message || res?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        console.error(msg);
        // alert(msg);
      }
      console.log(error.message);
    }
  };

  return (
    <div>
      {showTable && (
        <div>
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                Project List 
              </h5>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleShowCreate}
              >
                <img className="width20px" src={AddIcon} alt="AddIcon" />
                <span> Create Project </span>
              </button>
            </div>
          </div>

          {isLoading ? (
            <PaginatedTable
              row={list}
              column={column}
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isSearch={true}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              maxPageNumberLimit={maxPageNumberLimit}
              setMaxPageNumberLimit={setMaxPageNumberLimit}
              minPageNumberLimit={minPageNumberLimit}
              setMinPageNumberLimit={setMinPageNumberLimit}
              //   setRange={setRange}
              //   range={range}
              isExport={false}
              isDateRange={false}
              //   handleExport={() => handleExportTransactions()}
            />
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </div>
      )}

      {showCreate && <AddProject back={back} />}
    </div>
  );
};

export default AdminList;
